import React from 'react';
import { PropTypes } from 'prop-types';
import ReactCountryFlag from 'react-country-flag';
import { useTranslation } from 'react-i18next';
import images from '~/constants/images';
import { Responsive } from '~/components';
import { useSelector } from 'react-redux';
import * as S from './styles';

const PlayerHeader = ({
  name,
  isLocal,
  onClose,
  photo,
  nickname,
  shield,
  shirtNumber,
  country,
}) => {
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);

  return (
    <S.PlayerHeader isLocal={isLocal} competition={match?.competitionId}>
      <S.ShieldBackground bgImage={shield} isLocal={isLocal} />
      <div>
        <S.CloseButton isLocal={isLocal} onClick={onClose}>
          <S.CloseButtonText>{t('close')}</S.CloseButtonText>
          <S.CloseButtonIcon
            name="close"
            color={isLocal ? 'black' : 'white'}
            size={12}
          />
        </S.CloseButton>
        <S.PlayerHeaderImage src={photo || images.playerPlaceholder} />
        <Responsive
          sm={
            <S.PlayerHeaderInfo isLocal={isLocal}>
              <ReactCountryFlag
                styleProps={{
                  width: '30px',
                  height: '20px',
                }}
                code={country ? country.toLowerCase() : ''}
                svg
              />
              <S.PlayerName>{name || '--'}</S.PlayerName>
              <S.PlayerNickname>{nickname || '--'}</S.PlayerNickname>
              <S.PlayerNumber>{shirtNumber || '00'}</S.PlayerNumber>
            </S.PlayerHeaderInfo>
          }
          lg={
            <S.PlayerHeaderInfo isLocal={isLocal}>
              <S.PlayerHeaderInfoNum>
                <ReactCountryFlag
                  styleProps={{
                    width: '30px',
                    height: '20px',
                  }}
                  code={country ? country.toLowerCase() : ''}
                  svg
                />
                <S.PlayerNumber>{shirtNumber}</S.PlayerNumber>
              </S.PlayerHeaderInfoNum>
              <S.PlayerHeaderInfoName>
                <S.PlayerName>{name}</S.PlayerName>
                <S.PlayerNickname>{nickname}</S.PlayerNickname>
              </S.PlayerHeaderInfoName>
            </S.PlayerHeaderInfo>
          }
        />
      </div>
    </S.PlayerHeader>
  );
};

PlayerHeader.propTypes = {
  name: PropTypes.string,
  nickname: PropTypes.string,
  photo: PropTypes.string,
  isLocal: PropTypes.bool,
  onClose: PropTypes.func,
  shield: PropTypes.string,
  shirtNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  country: PropTypes.string,
};

PlayerHeader.defaultProps = {
  name: '',
  nickname: '',
  photo: '',
  isLocal: false,
  onClose: () => {},
  shield: '',
  shirtNumber: 0,
  country: '',
};

export default PlayerHeader;
